import { useTranslation } from 'react-i18next';
import {
  useAppSettingsDictionary,
  useDepositWithdrawAssetsDictionary,
} from '@/shared/api';
import { formatReceivedAmount } from '@/shared/lib';
import type { DepositMethod } from './types';

const COMMISSION_TEXT_KEYS = {
  erip: 'eripCommissionText',
  oplati: 'oplatiCommissionText',
} as const;

export function useDepositInstructionFooter(depositMethod: DepositMethod) {
  const { t } = useTranslation();
  const { appSettingsData } = useAppSettingsDictionary();
  const { depositWithdrawAssetsData } = useDepositWithdrawAssetsDictionary();

  const fiatItem = depositWithdrawAssetsData?.value?.deposit?.fiat?.find(
    item => Object.keys(item)[0] === depositMethod
  ) as Record<DepositMethod, Array<{ code: string; min: number }>> | undefined;
  const minAsset = fiatItem?.[depositMethod]?.[0];

  const minAmountText = minAsset
    ? t('depositMethods.minDepositAmount', {
        amount: formatReceivedAmount(minAsset.min),
        currency: minAsset.code,
      })
    : '';

  const commissionText =
    appSettingsData?.value?.depositWithdrawInformation?.[
      COMMISSION_TEXT_KEYS[depositMethod]
    ] ?? '';

  return [minAmountText, commissionText].filter(Boolean).join('. ');
}
